











































































































// Vue
import Vue from "vue";
// Vuex
import { mapActions, mapGetters } from "vuex";
// vue-draggable
import draggable from "vuedraggable";
// Models
import { AuthUser } from "@/core/_models/authUser.model";
import { _Error } from "@/core/_models/_error.model";
// Services
import SystemService from "@/views/system/System.service";
import AuthService from "@/core/services/auth.service";

// Components
import CreateSystemClientDialog from "@/views/system/_dialogs/clients/CreateSystemClientDialog.vue";
import UpdateSystemClientDialog from "@/views/system/_dialogs/clients/UpdateSystemClientDialog.vue";
import ConfirmationDialog from "@/core/components/content/_dialogs/ConfirmationDialog.vue";
import { ClientModel } from "@/core/api/apiClient";

export default Vue.extend({
  name: "Clients",
  components: { draggable, CreateSystemClientDialog, ConfirmationDialog, UpdateSystemClientDialog },

  data() {
    return {
      search: "",
      isLoading: false,
      isSearching: false,

      clientsData: [] as ClientModel[]
    };
  },

  beforeMount() {
    this.getAllClients();
    this.fetchClients();
  },

  methods: {
    ...mapActions("clients", {
      fetchClients: "fetchClients",
      setClient: "setClient",
      removeClient: "removeClient"
    }),

    getAllClients(): void {
      this.isLoading = true;

      SystemService.getAllClients().then((data: ClientModel[]) => {
        if (!data) return;

        this.$set(this, "clientsData", data);
        this.isLoading = false;
      });
    },

    getImageUrlWithCacheBust(imageUrl: string): string {
      if (!imageUrl) return imageUrl;
      const separator = imageUrl.includes("?") ? "&" : "?";
      return `${imageUrl}${separator}t=${Date.now()}`;
    },

    resetSearch(): void {
      this.search = "";
      this.isSearching = false;
    },

    startImpersonation(client: ClientModel): void {
      AuthService.impersonateLogin(client.clientId).then((data: AuthUser | _Error) => {
        if (!data) return;
        if (data instanceof _Error) return;

        this.$store.dispatch("LOGOUT");

        this.$store.dispatch("LOGIN", data);

        // Set the currentUser's Main Theme Color
        this.$vuetify.theme.themes.light.primary = AuthService.getMainThemeColor();

        // Update Job Dashboard and Calendar with impersonated Client's data
        this.$store.dispatch("SET_UPDATE_DASHBOARD", true);
        this.$store.dispatch("SET_UPDATE_CALENDAR", true);
        this.$store.dispatch("SET_UPDATE_SCHEDULER", true);
      });
    },

    updateClient(index: number, updatedClient: ClientModel): void {
      this.setClient(updatedClient).then(() => {
        this.getAllClients();
      });

      this.resetSearch();
    },

    deleteClient(clientToDelete: ClientModel): void {
      this.removeClient(clientToDelete).then(() => {
        this.getAllClients();
      });

      this.resetSearch();
    }
  },

  computed: {
    ...mapGetters({
      items: "clients/items",
      currentUser: "currentUser"
    }),
    clients: {
      get(): any {
        return this.items;
      }
    },

    /**
     * Filters SystemClients via search bar
     * @author Nick Brahimir
     */
    filteredClients(): ClientModel[] {
      return this.clientsData.filter((element: ClientModel): any => {
        return element.name?.toLowerCase().includes(this.search.toLowerCase());
      });
    },

    /**
     * Animations for Drag n Drop (see docs below)
     * https://www.npmjs.com/package/vuedraggable
     * https://sortablejs.github.io/Vue.Draggable/#/transition-example-2
     * https://github.com/SortableJS/Vue.Draggable/blob/master/example/components/transition-example-2.vue
     * @author Nick Brahimir
     */
    dragOptions() {
      return {
        animation: 200,
        disabled: true, // Disabling DnD for SystemClients.
        ghostClass: "ghost" // Corresponds to the scoped scss class.
      };
    },

    dragOff() {
      return {
        disabled: true
      };
    }
  }
});
